import styles from './SafetyAlertNotification.module.scss';
import { useTranslation } from 'react-i18next';
import { useLivePersonnelSafetyNotificationsApi } from '@casops/store/apis/useLivePersonnelSafetyNotificationsApi';
import { Link } from 'react-router-dom';
import { ModelName } from '@casops/store/api';
import CustomNotification from '@cas/components/data-display/custom-notification/CustomNotification';
import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';

const LINK_DURESS = '/assets/safety/duress';
const LINK_MAN_DOWN = '/assets/safety/man-down';

export function SafetyAlertNotification() {
  const { t } = useTranslation();

  const notifications = useLivePersonnelSafetyNotificationsApi();

  if (notifications && (notifications.ds > 0 || notifications.md > 0)) {
    return (
      <div className={styles.container}>
        <CustomNotification
          badgeStatus={BadgeStatus.Danger}
          icon="caution"
          title={<div className={styles.title}>{t('Banner.PersonnelSafety.Title')}</div>}
          tooltipLabel={t('Banner.PersonnelSafety.TooltipLabel')}
          message={
            <div slot="body" className={styles.actions}>
              {notifications.ds > 0 && (
                <Link key="duress" to={LINK_DURESS} className={styles.link}>
                  {t('Banner.PersonnelSafety.LinkLabel', {
                    count: notifications.ds,
                    modelName: ModelName.SafetyAlertDuress,
                  })}
                </Link>
              )}

              {notifications.md > 0 && (
                <Link key="mandown" to={LINK_MAN_DOWN} className={styles.link}>
                  {t('Banner.PersonnelSafety.LinkLabel', {
                    count: notifications.md,
                    modelName: ModelName.SafetyAlertManDown,
                  })}
                </Link>
              )}
            </div>
          }
        />
      </div>
    );
  }

  return null;
}

export default SafetyAlertNotification;
